export default n => {
  const str = String(n);
  const splitData = str.split('');
  const indexOfDecimal = splitData.indexOf('.');
  let slicedData;
  if (indexOfDecimal === -1) {
    // If there is no decimal add it and add two 0's
    splitData.splice(splitData.length, 0, '.', '0', '0');
    slicedData = splitData;
  } else if (splitData.length - indexOfDecimal > 2) {
    // If the decimal has more than 2 places after it then
    // strip out any additional numbers we dont need
    slicedData = splitData.slice(0, indexOfDecimal + 3);
  } else {
    // If there is a decimal but not enough digits past the decimal
    // add additional 0's to fill it up
    slicedData = splitData.concat(
      new Array(3 - (splitData.length - indexOfDecimal)).fill('0'),
    );
  }

  const joinedData = slicedData.join('');
  return `$${joinedData}`;
};
